












import { defineComponent } from '@vue/composition-api';
import useDeliveryNoteStatus from '@/useDeliveryNote';

const TransportItem = defineComponent({
  props: {
    index: { type: Number },
    driver: { type: String },
    license: { type: String },
    number: {
      type: [String, Number],
    },
    status: { type: String },
    color: { type: String },
  },
  setup() {
    const { deliveryNoteStatusClassMap, translate } = useDeliveryNoteStatus();
    return {
      deliveryNoteStatusClassMap,
      translate,
    };
  },
});

export default TransportItem;
